import stateClass from '../baseState';
import {DefaultState} from '../schoolMenu/reducer';

var yellow = 'rgb(228, 218, 100)';

const CHANGE_EVENT = 'change';

class indicatorClass extends stateClass{

    constructor(props) {
        super(props);

        this.groups = DefaultState.data[0].childs[1].childs; //

        this.colors = [
            'rgb(157, 159, 162)',
            'rgb(0, 155, 177)',
            'rgb(101, 160, 206)',
            'rgb(213, 225, 234)',
            yellow,
            'rgb(251, 175, 93)',
            'rgb(243, 116, 67)',
            'rgb(237, 20, 91)',
        ];
    }

    getColors(){
        return this.getGroup(this.chartKey).colors;
    }

    getGroups(){
        return this.groups;
    }

    getSizeField() {

        for (var i = this.groups.length - 1; i >= 0; i--) {
            if(this.groups[i].id === this.chartKey){
                return this.groups[i].sizeField;
            }
        }
    }
    getActiveGroup() {

        return this.getGroup(this.chartKey);
    }
    getGroup(id) {
        
        for (var i = this.groups.length - 1; i >= 0; i--) {
            if(this.groups[i].id === id) {
                return this.groups[i];
            }
        }

        return false;
    }
// data = {OCE_grupa: [{id: "<30%", "name": "<30%"}, ...], ...}
    update(data) {

        //reorder data by field values
        console.log('UPDATE INDICATORS STATE DATA', data);

    /*  for(var key in data) {
            //field values 
            var fieldDef = data[key]; 
            var group = this.getGroup(key);

            fieldDef.sort(function(a, b) {

                return group.order.indexOf(a.id) > group.order.indexOf(b.id);
            });
        }*/


        for (var i = this.groups.length - 1; i >= 0; i--) {
            
            this.data[this.groups[i].id] = [];

            for (var n =0, len = this.groups[i].order.length;  n < len; n++) {

                this.data[this.groups[i].id].push({id: this.groups[i].order[n], name:  this.groups[i].order[n]});
            }
        }

        
        
        this.emit(CHANGE_EVENT);
    }
}

var indicatorsState = new indicatorClass();

export {indicatorsState, CHANGE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/schoolQualityIndicators/state.js